<div class="forgot-password-container">
  <!-- Background com imagem -->
  <div class="forgot-password-background">
    <img src="/assets/grafismo/1.svg" alt="Background" class="background-image" loading="lazy">
  </div>

  <!-- Container principal -->
  <div class="forgot-password-content">
    <!-- Logo e título -->
    <div class="forgot-password-header">
             <div class="logo-container">
         <img src="../../../assets/logo/PNG/assinaturaVisual/amarelo.png" alt="AdvVenture Logo" class="forgot-password-logo" loading="lazy">
       </div>
      <h1 class="forgot-password-title">Esqueceu a senha?</h1>
      <p class="forgot-password-subtitle">Não se preocupe! Digite seu email e enviaremos instruções para redefinir sua senha.</p>
    </div>

    <!-- Formulário -->
    <form class="forgot-password-form" [formGroup]="formForgotPassword" (ngSubmit)="esqueceuSenha()">
      <!-- Campo de email -->
      <div class="form-group">
        <label class="form-label" for="email">
          <i class="pi pi-envelope"></i>
          Email
        </label>
        <div class="input-container">
          <input 
            class="form-input" 
            type="email" 
            id="email"
            formControlName="email" 
            autocomplete="email"
            placeholder="Digite seu email cadastrado"
            [ngClass]="{'input-error': form.email.touched && form.email.invalid}"
          >
          <div class="input-icon">
            <i class="pi pi-envelope"></i>
          </div>
        </div>
        <div class="error-message" *ngIf="form.email.touched && form.email.invalid">
          <span *ngIf="form.email.errors?.['required']">Por favor, informe o e-mail.</span>
          <span *ngIf="form.email.errors?.['email']">Por favor, informe um e-mail válido.</span>
        </div>
      </div>

      <!-- Botão de envio -->
      <div class="form-actions">
        <p-button 
          label="Enviar instruções" 
          type="submit"
          [disabled]="formForgotPassword.invalid || isSubmitting" 
          [loading]="isSubmitting"
          class="forgot-password-button"
        >
        </p-button>
      </div>

      <!-- Link de voltar -->
      <div class="forgot-password-links">
        <a class="link-back" (click)="navigateToLogin()">
          <i class="pi pi-arrow-left"></i>
          Voltar para o login
        </a>
      </div>
    </form>

    <!-- Informações adicionais -->
    <div class="forgot-password-info">
      <div class="info-card">
        <div class="info-icon">
          <i class="pi pi-info-circle"></i>
        </div>
        <div class="info-content">
          <h4>Como funciona?</h4>
          <p>Após enviar seu email, você receberá um link seguro para redefinir sua senha. O link expira em 24 horas.</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="forgot-password-footer">
      <p>&copy; 2024 AdvVenture. Todos os direitos reservados.</p>
    </div>
  </div>
</div>